import React from 'react';
import { Virtuoso } from 'react-virtuoso';

import { Spinner, View } from 'src/components/basic';
import { remCss } from '../utils';
import locationsModel from '../locationsModel';
import { SubLocation } from './Location';

export const Locations = (props) => {
  locationsModel.use();

  const items = locationsModel.items();
  const loading = locationsModel.refreshing();
  const noResults = locationsModel.noResults();

  return (
    <View
      style={{
        gap: remCss(40),
        flex: 1
      }}
    >
      <Virtuoso
        data={items}
        style={{ backgroundColor: 'white' }}
        components={{
          Header: () =>
            noResults &&
            !loading &&
            props.clinic?.id && <SubLocation clinic={props.clinic} {...props} />,
          Footer: () => (
            <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
              {loading && <Spinner />}
            </div>
          )
        }}
        endReached={() => {
          if (locationsModel.hasMore() && !locationsModel.refreshing()) locationsModel.loadMore();
        }}
        itemContent={(index, item) => <SubLocation location={item} {...props} key={index} />}
      />
    </View>
  );
};
